import React from 'react';

type Props = Record<string, never>;

const WhereIsMyString: React.FC<Props> = (props: Props) => {
  return null;
};

export default WhereIsMyString;
